export default {
    perfil: {
        error_server_connection: "Ops! Não foi possível excluir o perfil. Tente novamente mais tarde."
    },
    perfilForm: {
        unexpected_error: "Ops! Não foi possível cadastrar o perfil. Tente novamente mais tarde.",
        error_server_connection: "Ops! Não foi possível cadastrar o perfil. Tente novamente mais tarde.",
        fieldScope: {
            name: {
                already_exits: "Ops! Já existe um perfil cadastrado com esse nome. Por favor digite outro nome."
            }
        }
    },
    perfilFormEdit: {
        unexpected_error: "Ops! Não foi possível editar o perfil. Tente novamente mais tarde.",
        error_server_connection: "Ops! Não foi possível editar o perfil. Tente novamente mais tarde.",
        fieldScope: {
            name: {
                already_exits: "Ops! Já existe um perfil editar com esse nome. Por favor digite outro nome."
            }
        }
    },
    perfilDelete: {
        error_server_connection: "Ops! Não foi possível excluir o perfil. Tente novamente mais tarde.",
    },
    perfilFuncionalidades: {
        error_server_connection: "Ops! Não foi possível atualizar o controle de acesso. Tente novamente mais tarde.",
    }
}